import axios from "axios";
import { useEffect, useState } from "react";
import "./Admin.css";

const Admin = () => {

  const [users, setUsers] = useState([]);
  const [leaderboard, setLeaderboard] = useState([]);
  const [loading, setLoading] = useState(false);

  const [isAuth, setIsAuth] = useState(false);
  const [password, setPassword] = useState("");

  const [testRunning, setTestRunning] = useState(false); // 🔥 NEW

  /* ================= LOGIN ================= */

  const handleLogin = async () => {
    try {
      const res = await axios.post("/api/admin-login", { password });

      if (res.data.success) {
        setIsAuth(true);
        localStorage.setItem("admin_auth", "true");
      }

    } catch {
      alert("Wrong password");
    }
  };

  useEffect(() => {
    if (localStorage.getItem("admin_auth")) {
      setIsAuth(true);
    }
  }, []);

  /* ================= TEST CONTROL ================= */

  const startTest = async () => {
    await axios.post("/api/start-test");
    setTestRunning(true);
  };

  const stopTest = async () => {
    await axios.post("/api/stop-test");
    setTestRunning(false);
  };

  // 🔥 NEW: fetch REAL test status from backend (fixes tab close/reopen showing wrong status)
  const checkTestStatus = async () => {
    try {
      const res = await axios.get("/api/admin-test-status");
      setTestRunning(res.data.testStarted);
    } catch (err) {
      console.error(err);
    }
  };

  /* ================= API ================= */

  const fetchData = async () => {

    try {
      setLoading(true);

      const [userRes, lbRes] = await Promise.all([
        axios.get("/api/reaction-users"),
        axios.get("/api/webinar-leaderboard")
      ]);

      setUsers(userRes.data.users || []);
      setLeaderboard(lbRes.data.leaderboard || []);

    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {

    if (!isAuth) return;

    fetchData();
    checkTestStatus(); // 🔥 NEW: get real status on load

    const interval = setInterval(() => {
      fetchData();
      checkTestStatus(); // 🔥 NEW: keep status in sync every 3s too
    }, 3000);

    return () => clearInterval(interval);

  }, [isAuth]);

  /* ================= LOGIN UI ================= */

  if (!isAuth) {
    return (
      <div style={{ textAlign: "center", marginTop: "100px" }}>
        <h2>🔐 Admin Login</h2>

        <input
          type="password"
          placeholder="Enter Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          style={{ padding: "10px", width: "250px" }}
        />

        <br /><br />

        <button onClick={handleLogin}>
          Login
        </button>
      </div>
    );
  }

  /* ================= ADMIN PANEL ================= */

  return (
    <div className="admin-container">

      <h2 className="admin-title">🎛 Admin Panel</h2>

      {/* 🔥 STATUS */}
      <h3 style={{ color: testRunning ? "green" : "red" }}>
        {testRunning ? "🟢 LIVE" : "🔴 STOPPED"}
      </h3>

      {/* Logout */}
      <button
        onClick={() => {
          localStorage.removeItem("admin_auth");
          window.location.reload();
        }}
        style={{ marginBottom: "10px" }}
      >
        Logout
      </button>

      <br />

      {/* START */}
      <button
        className="start-btn"
        onClick={startTest}
        disabled={testRunning}
        style={{ marginRight: "10px" }}
      >
        🚀 Start Test
      </button>

      {/* STOP 🔥 */}
      <button
        onClick={stopTest}
        disabled={!testRunning}
        style={{
          padding: "10px 20px",
          background: "#dc3545",
          color: "#fff",
          border: "none",
          borderRadius: "5px",
          cursor: "pointer"
        }}
      >
        🛑 Stop Test
      </button>

      <div className={`admin-grid ${loading ? "fade" : ""}`}>

        {/* USERS */}
        <div className="users-box">
          <h3>🏁 Competition Users ({users.length})</h3>

          <ul>
            {users.map((user, index) => (
              <li key={index}>{user.name}</li>
            ))}
          </ul>
        </div>

        {/* LEADERBOARD */}
        <div className="leaderboard-box">

          <h3>🏆 Leaderboard</h3>

          <table>
            <thead>
              <tr>
                <th>Rank</th>
                <th>Name</th>
                <th>Best (ms)</th>
                <th>%</th>
              </tr>
            </thead>

            <tbody>
              {leaderboard.map((user, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{user.name}</td>
                  <td>{Math.round(user.bestReaction * 1000)} ms</td>
                  <td>{user.percentile}%</td>
                </tr>
              ))}
            </tbody>
          </table>

        </div>

      </div>

    </div>
  );
};

export default Admin;